import { Expose } from 'class-transformer'

export class DeviceCategoryType {
  @Expose() name: string

  @Expose({ name: 'total' })
  value: number
}
